/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Automatic_Save_Skipped_LockedInputs */



/**
* | output |
* | --- |
* | "Automatic save skipped: Project is locked by {email}" |
*
* @param {Automatic_Save_Skipped_LockedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_skipped_locked = /** @type {((inputs: Automatic_Save_Skipped_LockedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Skipped_LockedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Sauvegarde automatique ignorée : le projet est verrouillé par ${i?.email}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Automatisches Speichern übersprungen: Projekt ist von ${i?.email} gesperrt.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Salvataggio automatico saltato: il progetto è bloccato da ${i?.email}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Автоматическое сохранение пропущено: Проект заблокирован пользователем ${i?.email}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Guardado automático omitido: el proyecto está bloqueado por ${i?.email}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`自动保存已跳过：项目已被 ${i?.email} 锁定`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`自動保存をスキップしました: プロジェクトは ${i?.email} によってロックされています`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`स्वचालित सेव प्रक्रिया रोक दी गई: प्रोजेक्ट ${i?.email} द्वारा लॉक किया गया है।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Salvamento automático ignorado: O projeto está bloqueado por ${i?.email}`)
	return /** @type {LocalizedString} */ (`Automatic save skipped: Project is locked by ${i?.email}`)
});